import React from "react";

export function FormField({
  label,
  value,
  onChange,
  multiline = false,
  placeholder,
  readOnly = false,
  disabled = false
}: {
  label: string;
  value: string;
  onChange: (value: string) => void;
  multiline?: boolean;
  placeholder?: string;
  readOnly?: boolean;
  disabled?: boolean;
}): JSX.Element {
  const inputClass =
    "tw-w-full tw-rounded-xl tw-border tw-border-slate-200 tw-bg-white tw-px-3.5 tw-py-2.5 tw-text-sm tw-font-medium tw-transition placeholder:tw-text-slate-400 focus:tw-border-[#0f172a] focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-[#0f172a]/10 disabled:tw-bg-slate-100 disabled:tw-text-slate-500 disabled:tw-cursor-not-allowed";
  const textColorClass = readOnly && !disabled ? "tw-text-slate-400" : "tw-text-slate-900";
  const readOnlyClass =
    readOnly && !disabled ? " tw-bg-slate-50 tw-border-slate-200" : "";
  const computedInputClass = `${inputClass} ${textColorClass}${readOnlyClass}`;
  const labelMutedClass = readOnly && !disabled ? "tw-text-slate-400" : "tw-text-slate-500";

  return (
    <div className="tw-group tw-flex tw-flex-col tw-gap-1.5 tw-border-b tw-border-slate-100 tw-pb-4">
      <label
        className={`tw-text-[0.6rem] tw-font-semibold tw-uppercase tw-tracking-[0.3em] ${labelMutedClass}`}
      >
        {label}
      </label>
      {multiline ? (
        <textarea
          value={value}
          onChange={(event) => onChange(event.target.value)}
          placeholder={placeholder}
          rows={3}
          className={`${computedInputClass} tw-min-h-[6rem]`}
          readOnly={readOnly}
          disabled={disabled}
        />
      ) : (
        <input
          type="text"
          value={value}
          onChange={(event) => onChange(event.target.value)}
          placeholder={placeholder}
          className={computedInputClass}
          readOnly={readOnly}
          disabled={disabled}
        />
      )}
    </div>
  );
}
